import * as React from 'react';
import { SVGProps } from 'react';
import styled from 'styled-components';

const SVG = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8 2c.53 0 1.04.234 1.414.65.375.418.586.983.586 1.572v3.556c0 .59-.21 1.154-.586 1.571C9.04 9.766 8.53 10 8 10c-.263 0-.523-.057-.765-.17a2 2 0 0 1-.65-.48 2.253 2.253 0 0 1-.433-.722c-.1-.27-.152-.558-.152-.85V4.222c0-.59.21-1.154.586-1.571C6.96 2.234 7.47 2 8 2Z"
      stroke="currentColor"
      strokeWidth={1.5}
    />
    <path
      d="M12.344 9.389c-.344 1.11-.765 1.876-1.516 2.553C10.078 12.62 9.061 13 8 13c-1.06 0-2.078-.38-2.828-1.058C4.422 11.265 4 10.5 3.656 9.39M8 13v2"
      stroke="currentColor"
      strokeWidth={1.5}
    />
  </svg>
);

const StyledSvgMicrophone = styled(SVG)`
  font-size: ${props => (props.fontSize ? props.fontSize : '1.6rem')};
  color: ${({ color, theme }) =>
    color ? color : theme.colors.neutralColors.charcoal};
  vertical-align: middle;
  shape-rendering: inherit;
  transform: translate3d(0, 0, 0);
`;
export default StyledSvgMicrophone;
